








































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Emit } from "vue-property-decorator";
import { User } from "../interfaces/user";
import randomstring from "randomstring";

@Component
export default class GuestLogin extends Vue {
    public valid = false;
    public username: string = "";
    public email: string = "";

    @Emit() submit() {
        return;
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || "Required.",
            username: v =>
                v.length < 255 || (this.$t("guest.username.invalid") as string),
            email: v =>
                /^$|^[\w.-]+@[\w.-]+$/gi.test(v) ||
                (this.$t("guest.email.invalid") as string),
        };
    }

    public validate() {
        (this.$refs.form as Vue & { validate: () => void }).validate();
    }

    public loginAsGuest() {
        if (!this.valid) {
            return;
        }
        const guestUser: User = {
            id: `guest|${randomstring.generate()}`,
            email: this.email,
            name: this.username,
            surname: this.username,
            displayname: this.username,
            is_active: false,
            is_guest: true,
            own_studios: [],
            joined_studios: [],
            scripts: [],
        };
        this.$store.commit("setUser", { user: guestUser });

        // const elem = document.documentElement;
        // if (elem.requestFullscreen) {
        //     elem.requestFullscreen();
        // }

        this.submit();
    }

    public gotoRegisterLogin() {
        this.$auth.loginWithRedirect();
    }
}
